import { parseTranscript } from './transcriptModel';

export async function fetchTranscript(
  transcriptUrl,
  { fetchImpl = globalThis.fetch, signal } = {}
) {
  if (!transcriptUrl) {
    return null;
  }

  if (typeof fetchImpl !== 'function') {
    throw new Error('Fetch is not available');
  }

  const response = await fetchImpl(transcriptUrl, { signal });

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Transcript not available');
    }
    throw new Error(`Failed to load transcript: ${response.status}`);
  }

  return parseTranscript(await response.json());
}
